import React from "react";

import styles from "./CritterTile.module.css";

// Prevents the tile from being marked as complete when getting more info.
const killSignal = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const Info = ({ critter }) => {
  return (
    <>
      <div className={styles.info} onClick={killSignal}>
        i
      </div>
      <div className={styles.moreInfo} onClick={killSignal}>
        <div className={styles.name}>{critter.name}</div>
        <div className={styles.location}>{critter.location}</div>
      </div>
    </>
  );
};

export default Info;
